import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { fetchServer } from '../Base/modelManager'
import { message } from 'antd'
import CalculeTicpe from './CalculeTicpe'
import { Button, Col, Container, Form,  Row } from 'react-bootstrap'


class Ticpe extends React.Component {
    constructor(props) {
        super(props)




        this.state = {
            annees: [],
            periodes: [],
            selectedAnnee: '',
            periodeTypes: '',
            periodeValue: '',
            selectedPeriodicite: '',
            selectedPeriodiciteValue: undefined,
            typeTransport: 'M',
            data: undefined
        }
    }

    componentDidMount() {
        const request = {
            endPoint: this.props.apiUrl + '/Services/anneesTicpe',
            methode: 'GET',
            token: this.props.JWTToken
        }

        fetchServer(request,
            json => {
                this.setState({ annees: json.value })
            },
            error => message.error(error))
    }


    componentDidUpdate(prevProp) {
        if (prevProp.currentClient !== this.props.currentClient)
            this.setState({ data: undefined })
    }




    onError = (error) => {
        message.error(error)
    }


    render() {
        const { annees, selectedAnnee, periodeTypes, periodeValue, selectedPeriodicite, selectedPeriodiciteValue, typeTransport, data } = this.state
        const getlibePeriode = (periodeValue) => {
            if (periodeValue.periodicite === 'Trimestre') {
                switch (periodeValue.value) {
                    case 1:
                        return 'Janvier...Mars'

                    case 2:
                        return 'Avril...Juin'

                    case 3:
                        return 'Juillet...Septembre'

                    case 4:
                        return 'Octobre...Décembre'

                    default:
                        break;
                }
            }
            if (periodeValue.periodicite === 'Mois') {
                switch (periodeValue.value) {
                    case 1:
                        return 'Janvier'

                    case 2:
                        return 'Fevrier'

                    case 3:
                        return 'Mars'

                    case 4:
                        return 'Avril'

                    case 5:
                        return 'Mai'

                    case 6:
                        return '*Juin'

                    case 7:
                        return 'Juillet'

                    case 8:
                        return 'Août'

                    case 9:
                        return 'Septembre'

                    case 10:
                        return 'Octobre'

                    case 11:
                        return 'Novembre'

                    case 12:
                        return 'Décembre'

                    default:
                        break;
                }
            }
        }
        console.log(selectedAnnee, selectedPeriodicite, selectedPeriodiciteValue , typeTransport)

        return (

            <section>
                <Container>
                    <div style={{ display: 'block' }} >

                        <Row  className="justify-content-md-center ticpeHeader">
                            
                            - JE CALCULE MA TICPE -
                            
                        </Row>
                        <Form>
                            <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                <Form.Label column sm="2">
                                    Pour la période
                                </Form.Label>
                                <Col sm="2">
                                    <Form.Control as="select" value={selectedAnnee} onChange={(event) => {

                                        const newAnnee=event.target.value
                                        const request = {
                                            endPoint: this.props.apiUrl + '/Services/PeriodeAnneeTicpe?annee=' + newAnnee,
                                            methode: 'GET',
                                            token: this.props.JWTToken
                                        }

                                        fetchServer(request,
                                            json => {
                                                const periodeTypes = []
                                                const periodeValue = []
                                                json.value.forEach(item => {
                                                    if (periodeTypes.indexOf(item.periodicite) === -1)
                                                        periodeTypes.push(item.periodicite)
                                                    periodeValue.push(item)
                                                })
                                                this.setState({
                                                    periodeTypes: periodeTypes,
                                                    periodeValue: periodeValue,
                                                    selectedAnnee: newAnnee,
                                                    data: undefined
                                                })
                                            },
                                            error => message.error(error))
                                    }} >
                                        <option key={''} value={''}>{''}</option>
                                        {
                                            annees.map(item => {
                                                return (
                                                    <option key={item} value={item}>{item}</option>
                                                )
                                            })
                                        }


                                    </Form.Control>

                                </Col>
                                {
                                    periodeTypes !== '' ?
                                        <Col sm="2">

                                            <Form.Control as="select" value={selectedPeriodicite} onChange={(event) => {
                                                this.setState({ selectedPeriodicite: event.target.value, selectedPeriodiciteValue: '', data: undefined })
                                            }} >
                                                 <option key={''} value={''}>{''}</option>
                                                {
                                                    periodeTypes.map(item => {
                                                        return (
                                                            <option key={item} value={item}>{item}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Control>

                                        </Col>
                                        : null
                                }
                                {
                                    selectedPeriodicite !== '' ?
                                        <Col m="2">

                                            <Form.Control as="select" value={selectedPeriodiciteValue} onChange={(event) => {
                                                this.setState({ selectedPeriodiciteValue: event.target.value, data: undefined })
                                            }} >
                                                <option key={''} value={''}>{''}</option>
                                                {
                                                    periodeValue.filter(item => item.periodicite === selectedPeriodicite).map(item => {
                                                        return (
                                                            <option key={item.value} value={item.value}>{getlibePeriode(item)}</option>
                                                        )
                                                    })
                                                }
                                            </Form.Control>

                                        </Col>
                                        : null
                                }
                            </Form.Group>
                        </Form>
                        <Row>
                        <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                <Form.Label column sm="2">
                                je fais du transport de 
                                </Form.Label>
                                <Col sm="2">
                                    <Form.Control as="select" value={typeTransport} onChange={(value) => {
                                    this.setState({ typeTransport: value.currentTarget.value, data: undefined })
                                }}>
                                    <option value='P' key='P'>Personnes</option>
                                    <option value='M' key='M'>Marchandises</option>
                                </Form.Control>

                                </Col>
                                <Col sm="4"></Col>
                                <Col sm="4">
                                {selectedAnnee !== undefined && selectedPeriodicite !== undefined && selectedPeriodiciteValue !== undefined && typeTransport !== undefined ?
                                    <Button className='TicpeSend' onClick={() => {
                                        const request = {
                                            endPoint: this.props.apiUrl + '/Services/CalculTicpe?annee=' + selectedAnnee + '&periodicite=' + selectedPeriodicite + '&periode=' + selectedPeriodiciteValue + '&typeTransport=' + typeTransport,
                                            methode: 'GET',
                                            token: this.props.JWTToken
                                        }

                                        fetchServer(request,
                                            json => {
                                                this.setState({ data: json.value })
                                            },
                                            error => message.error(error))
                                    }}>Calculer</Button>

                                    : null
                                }
                                </Col>

                                </Form.Group>

                            
                        </Row>
                        {
                            data !== undefined ?
                                <CalculeTicpe {...this.state}/>
                                : null
                        }
                    </div>
                </Container>
            </section>
        )

    }
}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

Ticpe.propTypes = {
    dispatch: PropTypes.func,
    apiUrl: PropTypes.string,
    clients: PropTypes.array,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string
};

export default connect(mapStateToProps)(Ticpe);
